<template>
    <div>
        <v-container fluid class="grey-container cta-container" :style="{ 'min-height': '800px', 'background-size': 'contain', 'background-color': '#E6E6E6', 'background-image': 'url(' + getBackground + ')' }">
            <v-container class="contain-width">

                <v-row>
                    <v-col
                            md="6"
                            offset-md="3"
                    >
                        <h1 class="md-display-2 white--text mb-6">{{ $t('headings.New password') }}</h1>
                        <v-card
                                class="mx-auto form-card"
                                outlined
                        >

                            <v-card-text class="text--primary">
                                <ValidationObserver ref="observer">
                                    <v-form autocomplete="off" v-model="valid" @submit.prevent="resetPassword">

                                        <ValidationProvider vid="email" :name="$t('labels.Email')" rules="required|email" v-slot="{ errors }">
                                            <v-text-field
                                                    v-model="email"
                                                    :error-messages="errors[0]"
                                                    :label="$t('labels.Email')"
                                                    required
                                            ></v-text-field>
                                        </ValidationProvider>

                                        <ValidationProvider vid="password" :name="$t('labels.Password')" rules="required|min:8" v-slot="{ errors }">
                                            <v-text-field
                                                    v-model="password"
                                                    :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                                    :type="showPassword ? 'text' : 'password'"
                                                    :error-messages="errors[0]"
                                                    :label="$t('labels.Password')"
                                                    required
                                                    ref="password"
                                                    autocapitalize="none"
                                                    @click:append="showPassword = !showPassword"
                                            ></v-text-field>
                                        </ValidationProvider>

                                        <ValidationProvider vid="confirmation" :name="$t('labels.Password confirmation')" rules="required|password:password" v-slot="{ errors }">
                                            <v-text-field
                                                    v-model="password_confirmation"
                                                    :append-icon="showPasswordConfirm ? 'visibility' : 'visibility_off'"
                                                    :type="showPasswordConfirm ? 'text' : 'password'"
                                                    :error-messages="errors[0]"
                                                    :label="$t('labels.Password confirmation')"
                                                    required
                                                    autocapitalize="none"
                                                    @click:append="showPasswordConfirm = !showPasswordConfirm"
                                            ></v-text-field>
                                        </ValidationProvider>
                                    </v-form>
                                </ValidationObserver>
                                <div class="d-flex justify-end">
                                    <v-btn tile elevation="0" color="primary" @click="resetPassword">{{ $t('buttons.Update') }}</v-btn>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
        <Footer />
    </div>
</template>

<script>

    import axios from "axios";
    import { store } from '../store';

    import { extend } from 'vee-validate';

    import Footer from './Footer'
    import {i18n} from "../i18n";
    import {mapState} from "vuex";

    extend('password', {
        validate: (value, { other }) => value === other,
        message: i18n.t('The password confirmation does not match') + '.',
        params: [{ name: 'other', isTarget: true }]
    });

    extend('min', {
        validate: (value, { min }) => {
            const length = value && value.length;

            return length >= min;
        },
        params: ['min'],
        message: i18n.t('The {_field_} length must be a minimum of {min} characters')
    });

    export default {
        name: "ResetPasswordForm",
        components: {
            'Footer': Footer
        },
        metaInfo() {
          return {
            title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t('headings.New password'),
            htmlAttrs: {
              lang: i18n.locale
            }
          }
        },
        data() {
            return {
                token: null,
                email: '',
                password: '',
                password_confirmation: '',
                has_error: false,
                valid: false,
                showPassword: false,
                showPasswordConfirm: false
            }
        },
        mounted () {
            this.$gtag.pageview({
                page_path: '/#/reset-password/:token'
            })

            document.getElementById("scrolling-content").scrollTop = 0
        },
        computed: {
          ...mapState({
            brand: state => state.brand,
            brandName: state => state.brandName
          }),
          getBackground() {
            if (this.brand === 'neotag') {
              return require('@/assets/neotag-background.jpg')
            }
            else {
              return require('@/assets/neotag-background.jpg')
            }
          },
        },
        methods: {
            capitalizeFirstLetter(string) {
              return string.charAt(0).toUpperCase() + string.slice(1);
            },
            async resetPassword() {

                let observer = this.$refs.observer;

                const isValid = await observer.validate();

                if (isValid) {

                    let apiClient = axios.create({
                        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
                        headers: {'Accept-Language': i18n.locale},
                        withCredentials: false,
                    });

                    return apiClient
                        .post('/reset-password', {
                            token: this.$route.params.token,
                            email: this.email,
                            password: this.password,
                            password_confirmation: this.password_confirmation
                        })
                        .then(response => {

                            if (response.status === 200) {
                                this.$router.push({name: 'login'}).then(() => {
                                    store.dispatch('alert/success', i18n.t('Password reset successfully'), {root: true});
                                })

                            }
                            else {
                                store.dispatch('alert/error', i18n.t('Unknown error occurred'), {root: true});
                            }

                        })
                        .catch(function (error) {
                            console.error(error);
                            // Add the server side errors for each field.
                            if (error.response.status === 422) {

                                // store server side validation errors
                                return store.dispatch('validationErrors', error.response.data.errors, {root: true}).then(response => {
                                    observer.setErrors(store.getters.validationErrors);
                                });

                            }
                        });
                }
            }
        }
    }
</script>

<style scoped>
    button {
        text-transform: none;
    }
    .product-card {
        border-radius: 15px 15px 0 0;
        border: none !important;
    }
</style>
